export default __webpack_public_path__ + "static/media/liederland-swissmom-special.dbe88d68.webp";